import { createI18n } from '@starling/core/i18n';

import ru from './locales/ru.json';
import kk from './locales/kk.json';

// i18next-настройка Light. RU — основной язык, KK — плейсхолдер для M2.
// fallbackLng=ru гарантирует, что неполный KK-перевод не сломает UI.
// Механика init (синхронный initImmediate=false, guard по isInitialized) —
// в общей обвязке `@starling/core/i18n` (V1.2-a); здесь только словари.
const i18n = createI18n({
  resources: {
    ru: { translation: ru },
    kk: { translation: kk },
  },
  lng: 'ru',
  fallbackLng: 'ru',
});

export default i18n;
